import { render, staticRenderFns } from "./ActHeader.vue?vue&type=template&id=1d4472f0&"
import script from "./ActHeader.vue?vue&type=script&lang=js&"
export * from "./ActHeader.vue?vue&type=script&lang=js&"
import style0 from "./ActHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports